import { Component, OnInit } from '@angular/core';
import { ManagedContentService } from '../shared/service/managed-content.service';
import {ContentType} from '../shared/model/cm/managed-content.model';
import { Notice } from '../shared/model/session/notice';
import { PagetitleService } from '../shared/service/pagetitle.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NotFoundComponent implements OnInit {

  public readonly pageIllustrationUrl = '../assets/Illustration-Footer-Base-Mountains.svg';

  notFoundErrorContent: Notice;

  constructor(private cmService: ManagedContentService,
    private pagetitleService: PagetitleService) { }

  ngOnInit(): void {

    let notFoundError = this.cmService.getContentById(ContentType.HELP,"not-found-error");
    this.notFoundErrorContent = { 
      id: notFoundError.id, 
      title: notFoundError.title, 
      body: notFoundError.body 
    };

    this.pagetitleService.setPageTitle('Page Not Found');
  }

}
